import React, { useRef, useState, useEffect } from 'react'
import './CreateImportDataTemplateModal.scss'
import { Button, Form, Input, Modal, Select } from 'antd'
import DraggableListSorting from './DraggableListSorting'
import { mixGetV2, mixPostV2 } from '../../../../services/mixin'
import useToast from '../../../../hook/useToast';
import { API_URL_v2 } from "../../../../env";
interface Props {
  show: boolean
  modalClose?: () => void
  modalFinish?: () => void
  listSource?: []
  listSourceV2?: []
}

const CreateImportDataTemplateModal: React.FC<Props> = (props) => {
  const pushToast = useToast();
  const formRef: any = useRef(null)
  const { show, modalClose, modalFinish, listSource, listSourceV2 } = props
  const [loading, setLoading] = useState(false)
  const [selectedItems, setSelectedItems] = useState<any>([])
  const [sourceId, setSourceId] = useState<any>(null)

  const onFormSubmit = () => {
    formRef?.current.submit()
  }

  const [idsNotReady, setIdsNotReady] = useState([] as any)
  const onFormFinish = async (values: any) => {
    if (selectedItems.length === 0) {
      pushToast(`Vui lòng thêm dòng hoặc tải file excel lên.`, "warning");
      return;
    }
    const notValidIds = selectedItems.filter((item: any) => !item.code || !item.text).map((item: any) => item.id);
    setIdsNotReady(notValidIds);
    if (notValidIds.length > 0) {
      pushToast(`Có ${notValidIds.length} trường dữ liệu bị thiếu.`, "warning");
      return;
    }
    // Kiểm tra trùng text trong selectedItems
    const texts = selectedItems.map((item: any) => item.text?.trim());
    const duplicateTexts = texts.filter((text: any, idx: any) => texts.indexOf(text) !== idx && text);
    if (duplicateTexts.length > 0) {
      pushToast("Có trường dữ liệu bị trùng tên.", "warning");
      return;
    }
    // Tạo file Excel với tiêu đề là selectedItems -> text
    // const XLSX = await import('xlsx');
    // const header = selectedItems.map((item: any) => item.text);
    // const ws = XLSX.utils.aoa_to_sheet([header]);
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, "Template");
    // XLSX.writeFile(wb, `${values.templateName || 'template'}.xlsx`);
    const param = {
      name: values.templateName,
      template_table: '[]',
      source_id: values.source_id || 0,
      data_json: JSON.stringify(selectedItems),
    }
    setLoading(true)
    const res = await mixPostV2('/api/v1/be/template_excel', param)
    if (res.status) {
      savePramMap()
      pushToast("Thao tác thành công", "success")
      setLoading(false)
      setSelectedItems([])
      setSourceItems([])
      setSourceId(null)
      formRef?.current.resetFields()
      if (modalFinish) {
        modalFinish()
      }
      const XLSX = await import('xlsx');
      const header = selectedItems.map((item: any) => item.text);
      const ws = XLSX.utils.aoa_to_sheet([header]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Template");
      XLSX.writeFile(wb, `${values.templateName || 'template'}.xlsx`);
    } else {
      pushToast("Error!", "warning")
      setLoading(false)
    }
  }

  const savePramMap = async () => {
    const tempItems = JSON.parse(JSON.stringify(selectedItems)) as any
    const tempParamMap = JSON.parse(JSON.stringify(paramMap)) as any

    tempItems.map((data: any) => {
      tempParamMap.forEach((item: any) => {
        if (Array.isArray(item.data)) {
          item.data = item.data.filter((text: any) => text !== data.text);
        }
      });
      const findData = tempParamMap.find((x: any) => x.column === data.code)
      if (findData) {
        if (Array.isArray(findData.data)) {
          if (!findData.data.includes(data.text)) {
            findData.data.push(data.text);
          }
        } else {
          findData.data = [data.text];
        }
      } else {
        tempParamMap.push({
          column: data.code,
          data: [data.text],
          source_id: sourceId,
        })
      }
      return true
    })
    const res = await mixPostV2('/api/v1/be/setting_mapping', {
      value: JSON.stringify(tempParamMap),
      type: 2,
    })
    if (res.status) {
      getParamMap()
    }
  }

  const onModalClose = () => {
    setSelectedItems([])
    setSourceItems([])
    setSourceId(null)
    setIdsNotReady([])
    formRef?.current.resetFields()

    if (modalClose) {
      modalClose()
    }
  }

  const [sourceItems, setSourceItems] = useState<any>([])
  let wait1 = false
  const getcolumn = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2(`/api/v1/be/source_column_warehouses?is_active=1`)
    wait1 = false
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        const listSourceIds = [] as any
        val.params_key.map((val: any) => {
          listSourceIds.push(val.source_id)
          return true
        })
        temp.push({ id: val.id, name: val.name, column: val.column_warehouse.column, source_id: listSourceIds })
        return true
      })
      setSourceItems([...temp])
    }
  }

  let wait4 = false
  const [paramMap, setParamMap] = useState([] as any)
  const getParamMap = async () => {
    if (wait4) {
      return
    }
    wait4 = true
    const res = await mixGetV2('/api/v1/be/setting_mapping?type=2')
    wait4 = false
    if (res.status) {
      setParamMap([...JSON.parse(res.data.value || '[]')])
    }
  }
  useEffect(() => {
    // getcolumn()
    getParamMap()
  }, [])

  return (
    <Modal
      open={show}
      title='Tạo mới template import dữ liệu vào trung tâm dữ liệu'
      className='rs-modal w-769 import-data-template-modal footer-content-end'
      maskClosable={false}
      keyboard={false}
      centered
      footer={() => (
        <>
          <Button
            className="rs-button"
            onClick={onModalClose}
          >Hủy</Button>
          <Button
            type="primary"
            loading={loading}
            className="rs-button"
            onClick={onFormSubmit}
          >Lưu và tải về</Button>
        </>
      )}
      onCancel={onModalClose}
    >
      <Form
        ref={formRef}
        className='rs-form'
        requiredMark={false}
        onFinish={onFormFinish}
      >
        <Form.Item
          label="Tên mẫu template"
          name="templateName"
          rules={[
            { required: true, message: 'Vui lòng nhập tên mẫu template' },
          ]}
        >
          <Input placeholder='Nhập tên' className='rs-input rs-input--32' />
        </Form.Item>

        <Form.Item
          label="Nguồn"
          name="source_id"
        >
          <Select
            placeholder='Chọn nguồn'
            className="rs-select"

            options={listSourceV2}
            allowClear
            onChange={(value) => {
              setSourceId(value);
            }}
          />
        </Form.Item>

        <DraggableListSorting
          items={sourceItems}
          sourceId={sourceId}
          idsNotReady={idsNotReady}
          paramMap={paramMap}
          source={listSourceV2?.map((val: any) => ({ name: val.label, id: val.value }))}
          onChange={(items) => {
            setSelectedItems(items)
            if (idsNotReady.length > 0) {
              const notValidIds = items.filter((item: any) => !item.code || !item.text).map((item: any) => item.id);
              setIdsNotReady(notValidIds);
            }
          }}
        />
      </Form>
    </Modal>
  )
}

export default CreateImportDataTemplateModal
